import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "state",
    serviceName: "graphql",
    query: gql`
      query state($ids: [String]) {
        state(ids: $ids) {
          data {
            title
            details
          }
          total
        }
      }
    `,
  },
  update: {
    name: "updateState",
    serviceName: "admin",
    query: gql`
      mutation updateState($ids: [String]!, $title: String, $details: String) {
        updateState(ids: $ids, title: $title, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
